import { render, staticRenderFns } from "./MyCkEditorDialog.vue?vue&type=template&id=a812689a&"
import script from "./MyCkEditorDialog.vue?vue&type=script&lang=js&"
export * from "./MyCkEditorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports